import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { fetchDataFromMicroCMS } from '../utils/microCMSApi';

interface Member {
    memberType: string[];
    name: string;
    logo: { url: string };
}

interface CoWorkingMemberProps {
    addMargin?: boolean;
}

interface MembersResponse {
    contents: Member[];
}

const CoWorkingMemberList: React.FC<CoWorkingMemberProps> = ({ addMargin = true }) => {
    const { t } = useTranslation();
    const [members, setMembers] = useState<Member[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchMembers = async () => {
            setLoading(true);
            try {
                const data = await fetchDataFromMicroCMS('members?limit=100') as MembersResponse;
                setMembers(data.contents);
            } catch (error) {
                console.error('Error fetching members:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMembers();
    }, []);

    const filterMembersByType = (type: string) => {
        return members.filter(member => member.memberType.includes(type));
    };

    const renderMembersSection = (type: string) => {
        const filteredMembers = filterMembersByType(type);
        if (filteredMembers.length === 0) return null;

        return (
            <div className="text-center">
                <h2 className="text-3xl font-bold mb-1">{t('cw_lp_member_2_type', { type })}</h2>
                <hr className="border-t mb-8" />
                <div
                    className={`${filteredMembers.length <= 2
                        ? 'flex justify-center items-center'
                        : 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-1'
                        }`}
                >
                    {filteredMembers.map((member, index) => (
                        <div key={index} className="flex flex-col justify-center items-center">
                            <img
                                src={member.logo.url}
                                alt={member.name}
                                width={200}
                                height={150}
                            />
                            <p className="mt-2 text-sm">{member.name}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="w-full text-[#2C2E35] mt-0 md:mt-10 ">
            <div className={`w-full px-4 py-10 ${addMargin ? 'pt-[85px]' : 'md:-mt-[3rem]'} max-w-7xl mx-auto`} id="members">
                <div className="relative">
                    <h1 className="text-5xl font-bold leading-[1.1] text-center">{t('cw_lp_home_11')}</h1>
                </div>
                {/*   <p className="text-md font-medium text-center py-10">
                    {t('cw_lp_member_2')}
                </p> */}
                <p className="text-center w-full pt-6">
                    <Trans i18nKey="cw_lp_member_1_a" components={[
                        <a href={t('cw_lp_member_registration_info_url')} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline" />
                    ]} />
                </p>
                <div className="w-full pt-6">
                    {loading ? (
                        <p className="text-center">{t('cw_lp_common.loading')}</p>
                    ) : members?.length > 0 ? (
                        <>
                            {renderMembersSection('Mentor')}
                            {renderMembersSection('Partner')}
                        </>
                    ) : <p className="text-center">{t('cw_lp_member_1')}</p>}
                </div>
            </div>
        </div>
    );
};

export default CoWorkingMemberList;
